export default {"src":"/_next/static/media/reason_for_deleting_account.fc84a673.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};